import { NotificationBell } from '@/components/common/NotificationBell';

export function AdminTopbar() {
  return (
    <header className="hidden md:flex items-center gap-4 bg-zoowhite border-b border-zooborder px-6 h-16 shrink-0">
      <div className="ml-auto flex items-center gap-2">
        <NotificationBell />
      </div>
    </header>
  );
}
